module.exports = __webpack_public_path__ + "static/media/waterpolo_icon-01.32a8e9cf.png";